import {memo} from "react";
import EndpointNumber, {EndpointType} from "../EndpointNumber";

export default memo((props: {domainId: number; id: number; type: EndpointType}) => {
    const {id, type} = props;
    return <EndpointNumber id={id} type={type} />;
});
